import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { useCallback } from 'react';
import getPropertyValue from '../../../dataAccessHelpers/getPropertyValue';
import { useAuthedUser } from '../../../hooks/useAuthedUser';
import { useSendAuthorizationCopyMutation } from '../../../hooks/useSendAuthorizationCopyMutation';
import { usageTracker } from '../../../utils/usageTracker';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Text } from 'foundations-components/components/Text';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function showSuccessAlert() {
  FloatingAlertStore.addAlert({
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendBankAuthorization.modal.successAlert"
    }),
    type: 'success'
  });
}
function showErrorAlert() {
  FloatingAlertStore.addAlert({
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendBankAuthorization.modal.errorAlert"
    }),
    type: 'danger'
  });
}
function SendAuthorizationCopyModal({
  properties,
  onClose
}) {
  const user = useAuthedUser();
  const [sendAuthorizationCopy, {
    loading
  }] = useSendAuthorizationCopyMutation({
    invoiceId: parseInt(getPropertyValue(properties, 'hs_platform_invoice_id'), 10),
    onError: showErrorAlert,
    onSuccess() {
      showSuccessAlert();
      usageTracker.track('paymentCRMSidebarUsage', {
        action: 'sendAuthorizationCopyModalSubmitClicked'
      });
      onClose();
    }
  });
  const handleSendAuthorizationCopy = useCallback(() => {
    /* eslint-disable-next-line @typescript-eslint/no-floating-promises */
    sendAuthorizationCopy();
  }, [sendAuthorizationCopy]);
  const handleSendAuthorizationCopyModalCancel = useCallback(() => {
    usageTracker.track('paymentCRMSidebarInteraction', {
      action: 'sendAuthorizationCopyModalCancelClicked'
    });
    onClose();
  }, [onClose]);
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: 600,
    "data-test-id": "send-authorization-copy-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendBankAuthorization.modal.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendBankAuthorization.modal.body",
        options: {
          email: user.email
        }
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(LoadingButton, {
        "data-test-id": "send-authorization-copy-modal-send-button",
        use: "primary",
        onClick: handleSendAuthorizationCopy,
        loading: loading,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendBankAuthorization.modal.send"
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "send-authorization-copy-modal-cancel-button",
        onClick: handleSendAuthorizationCopyModalCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendBankAuthorization.modal.cancel"
        })
      })]
    })]
  });
}
export default SendAuthorizationCopyModal;